module.exports = __webpack_public_path__ + "img/inno_2.569d3578.jpg";